import { memo } from 'react';

import { push } from 'connected-react-router';
import isNil from 'lodash/isNil';
import qs from 'query-string';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderNothing } from 'recompact';

import { setLocationAction, showLocationDebugAction } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';

import Debugger from './Debugger/container';

function makeMapStateToProps() {
  return (state: RootState) => {
    const { showDebug, preferredLocation } = state?.location ?? {};
    const pathname = state?.router?.location?.pathname;
    const { showLocationDebug } = qs.parse(state?.router?.location?.search ?? '');
    const parameters = state?.router?.location?.search;

    return {
      preferredLocation,
      showDebug,
      isShowLocationDebug: showLocationDebug ? showLocationDebug === 'true' : null,
      pathname,
      parameters,
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchShowLocationDebug: value => dispatch(showLocationDebugAction(value)),
  dispatchRedirectLocalizedRoute: newPath => dispatch(push(newPath)),
  dispatchSetLocationAction: location => dispatch(setLocationAction(location)),
});

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { isShowLocationDebug, dispatchShowLocationDebug } = this.props;
      if (!isNil(isShowLocationDebug)) {
        // if the showLocationDebug query parameter is set, update state
        dispatchShowLocationDebug(isShowLocationDebug);
      }
    },
  }),
  branch(({ showDebug }) => !showDebug, renderNothing),
  memo
)(Debugger);
